import { ReactElement } from 'react';

import { PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { StrongText, StyledFlex } from '@dreryk/react-components';

import { AttachmentsLinks } from '~legacy.patient';

import { mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments } from './PatientConsentsListItemContent.utils';

type PatientConsentsListItemContentProps = {
   readonly patientConsent: PatientConsentDocument;
   readonly onShowMoreAttachmentsClick: VoidFunction;
};

export const PatientConsentsListItemContent = (props: PatientConsentsListItemContentProps): ReactElement => {
   return (
      <StyledFlex direction={'column'} gap={7}>
         <StrongText testId={'consentName'}>{props.patientConsent.name}</StrongText>
         {props.patientConsent.attachments ? (
            <AttachmentsLinks
               attachments={mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments(
                  props.patientConsent.attachments
               )}
               onShowMoreAttachmentsClick={props.onShowMoreAttachmentsClick}
            />
         ) : null}
      </StyledFlex>
   );
};
